import React, { useEffect, useState } from 'react';
import { MaterialDetailsView } from './MaterialDetailsView';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchMaterial,
  updateMaterialInfo,
  updateMaterialSpecification,
  updateMaterialIngredient,
} from './MaterialDetailsActions';
import {
  MATERIAL_DETAILS_RESET,
  MATERIAL_SPECIFICATION_ADD,
  MATERIAL_SPECIFICATION_REMOVE,
  MATERIAL_INGREDIENT_ADD,
} from './MaterialDetailsTypes';
import { useTranslation } from 'react-i18next';
import { fetchMaterials } from '../Material/MaterialActions';

export default (props) => {
  const { t } = useTranslation(['materials', 'common', 'project', 'templates']);
  const dispatch = useDispatch();
  const materialDetails = useSelector((state) => state.materialDetails);
  const materials = useSelector((state) => state.material.data.docs);
  const [filters, setFilters] = useState({
    page: 0,
    limit: 20,
  });

  const getAll = () => {
    dispatch(fetchMaterials(filters));
  };
  const addSpecification = (specification) => {
    dispatch({
      type: MATERIAL_SPECIFICATION_ADD,
      payload: specification,
    });
  };

  const addIngredient = (ingredient) => {
    dispatch({
      type: MATERIAL_INGREDIENT_ADD,
      payload: ingredient,
    });
  };

  const removeSpecification = (testName) => {
    dispatch({
      type: MATERIAL_SPECIFICATION_REMOVE,
      payload: testName,
    });
  };

  useEffect(() => {
    getAll();
    return () => {
      dispatch({
        type: MATERIAL_DETAILS_RESET,
      });
    };
  }, []);

  const saveSpecification = async (data) => {
    const response = await dispatch(
      updateMaterialSpecification(props.match.params.id, data),
    );
    return response;
  };

  const saveIngredient = async (data) => {
    const response = await dispatch(
      updateMaterialIngredient(props.match.params.id, data),
    );

    return response;
  };

  const saveInformation = async (data) => {
    const response = await dispatch(
      updateMaterialInfo(props.match.params.id, data),
    );
    return response;
  };

  const goBackAction = () => {
    props.history.push('/dashboard/material');
  };

  const cancelSpecificationAction = () => {
    dispatch(fetchMaterial(props.match.params.id));
  };

  useEffect(() => {
    dispatch(fetchMaterial(props.match.params.id));
  }, [props.match.params.id]);

  return (
    <MaterialDetailsView
      data={materialDetails.data}
      addSpecification={addSpecification}
      removeSpecification={removeSpecification}
      saveSpecification={saveSpecification}
      cancelSpecificationAction={cancelSpecificationAction}
      saveInformation={saveInformation}
      addIngredient={addIngredient}
      goBackAction={goBackAction}
      saveIngredient={saveIngredient}
      materials={materials}
      t={t}
    />
  );
};
